import React, { useCallback, useEffect, useMemo, useRef, useState } from "react";
import { PipeSystem } from "./PipeSystem";
import { PipeIconSystem } from "./PipeIconSystem";
// import TextTransition, { presets } from "react-text-transition";
// import CountUp from "react-countup";
// import { ReactComponent as PipeIconsSvg } from "./icons.svg";
import numeral from "numeral";
// import uuid from "react-uuid";
import _ from "lodash";
// import { Link } from "react-router-dom";
import { buildUri, ROUTE } from "../misc";
import ReactResizeDetector from "react-resize-detector";

import { event as infographicExploreProviderEvent } from "../../Components/GA/Home/ExploreProvidersLinkButtonFromInfographic";

import styles from "./EInfographic.module.scss";
import { Link } from "react-router-dom";
import { CountUp } from "Components/StdCountUp";

export interface EInfographicProps {
    className?: string;
    waterServiceProviderCount: number;
    capitalOperationsSpentAmount: number;
    waterMainsLength: number;
    sewerageTreatmentPlantsCount: number;
    waterTreatmentPlantsCount: number;
    sewerageMainsLength: number;
    potableWaterSuppliedCapacity: number;
    connectedPropertiesCount: number;
}

const format = "0,0[.]00";

const getDecimalDigit = (value: number) => {
    if (value == null) return null;

    return `${value}`?.split(".")?.[1]?.length ?? 0;
};

const getStart = (value: number) => {
    const dec = getDecimalDigit(value);
    if (dec == null) return null;
    const beforeDecimalCount = `${value}`?.split(".")?.[0]?.length ?? 0;

    if (beforeDecimalCount === 0) return null;

    const beforeDecimalStart = parseInt(_.join(new Array(beforeDecimalCount).fill(0).fill(1, 0, 1), ""));
    const afterDecimalStart =
        dec === 0 ? 0 : parseFloat(_.join(new Array(dec).fill(0).fill(1, dec - 1, dec), "")) / Math.pow(10, dec);
    const start = beforeDecimalStart + afterDecimalStart;
    return start;
};

const settings = [
    {
        className: "water-service-provider-count",
        widthRatio: 0.0693,
        lineHeightRatio: 0.092446584
    },
    {
        className: "water-service-provider-count-label",
        widthRatio: 0.027733975,
        lineHeightRatio: 0.028889558
    },
    {
        className: "waters-mains-length",
        widthRatio: 0.067023774,
        lineHeightRatio: 0.069334938
    },
    {
        className: "waters-mains-length-label",
        widthRatio: 0.026578393,
        lineHeightRatio: 0.01502257
    },
    {
        className: "cap",
        widthRatio: 0.063557027,
        lineHeightRatio: 0.055467951
    },
    {
        className: "cap-label-1",
        widthRatio: 0.025422811,
        lineHeightRatio: 0.035823051
    },
    {
        className: "cap-label-2",
        widthRatio: 0.016178152,
        lineHeightRatio: 0.01502257
    },
    {
        className: "sewerage-treatment-plant-count",
        widthRatio: 0.063557027,
        lineHeightRatio: 0.057779115
    },
    {
        className: "sewerage-treatment-plant-count-label",
        widthRatio: 0.012711405,
        lineHeightRatio: 0.01502257
    },
    {
        className: "water-treatment-plant-count",
        widthRatio: 0.063557027,
        lineHeightRatio: 0.057779115
    },
    {
        className: "water-treatment-plant-count-label",
        widthRatio: 0.01502257,
        lineHeightRatio: 0.01502257
    },
    {
        className: "sewerage-mains-length",
        widthRatio: 0.062401444,
        lineHeightRatio: 0.069334938
    },
    {
        className: "sewerage-mains-length-label",
        widthRatio: 0.019644899,
        lineHeightRatio: 0.01502257
    },
    {
        className: "potable-supplied-amount",
        widthRatio: 0.06009028,
        lineHeightRatio: 0.069334938
    },
    {
        className: "potable-supplied-amount-suffix",
        widthRatio: 0.023111646,
        lineHeightRatio: 0
    },
    {
        className: "potable-supplied-amount-label",
        widthRatio: 0.023111646,
        lineHeightRatio: 0.01502257
    },
    {
        className: "connected-properties-count",
        widthRatio: 0.061245862,
        lineHeightRatio: 0.069334938
    },
    {
        className: "connected-properties-count-label",
        widthRatio: 0.028889558,
        lineHeightRatio: 0.01502257
    }
];

export const EInfographic: React.FC<EInfographicProps> = ({
    className = "",
    waterServiceProviderCount,
    capitalOperationsSpentAmount,
    waterMainsLength,
    sewerageTreatmentPlantsCount,
    waterTreatmentPlantsCount,
    sewerageMainsLength,
    potableWaterSuppliedCapacity,
    connectedPropertiesCount
    // waterServiceProviderCount = 77,
    // capitalOperationsSpentAmount = 3.94,
    // waterMainsLength = 44000,
    // sewerageTreatmentPlantsCount = 258,
    // waterTreatmentPlantsCount = 212,
    // sewerageMainsLength = 35500,
    // potableWaterSuppliedCapacity = 530000,
    // connectedPropertiesCount = 2043000
}) => {
    const [, setRefresh] = useState({ refresh: true });

    const ref = useRef();

    const currentTime = useRef(Date.now());
    const sleepingTime = useRef(200);

    const visible = useRef(false);
    const selfOnScroll = useRef(undefined);

    const waterServiceProviderCountSetup = useMemo(() => {
        // return visible.current
        //     ? waterServiceProviderCount == null
        //         ? "..."
        //         : `${numeral(waterServiceProviderCount).format(format)}`
        //     : ``;

        return visible.current
            ? waterServiceProviderCount == null
                ? { start: null, end: null, decimal: null }
                : {
                      start: getStart(waterServiceProviderCount),
                      end: waterServiceProviderCount,
                      decimal: getDecimalDigit(waterServiceProviderCount)
                  }
            : { start: null, end: null, decimal: null };

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [visible.current, waterServiceProviderCount]);

    const capitalOperationsSpentAmountSetup = useMemo(() => {
        // return visible.current
        //     ? capitalOperationsSpentAmount == null
        //         ? "..."
        //         : `$${numeral(capitalOperationsSpentAmount).format(format)}`
        //     : ``;

        return visible.current
            ? capitalOperationsSpentAmount == null
                ? { start: null, end: null, decimal: null }
                : {
                      start: getStart(capitalOperationsSpentAmount),
                      end: capitalOperationsSpentAmount,
                      decimal: getDecimalDigit(capitalOperationsSpentAmount)
                  }
            : { start: null, end: null, decimal: null };

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [visible.current, capitalOperationsSpentAmount]);
    // }, [test]);

    const waterMainsLengthSetup = useMemo(() => {
        // return visible.current
        //     ? waterMainsLength == null
        //         ? "..."
        //         : `${numeral(waterMainsLength).format(format)}`
        //     : ``;

        return visible.current
            ? waterMainsLength == null
                ? { start: null, end: null, decimal: null }
                : {
                      start: getStart(waterMainsLength),
                      end: waterMainsLength,
                      decimal: getDecimalDigit(waterMainsLength)
                  }
            : { start: null, end: null, decimal: null };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [visible.current, waterMainsLength]);

    const sewerageTreatmentPlantsCountSetup = useMemo(() => {
        // return visible.current
        //     ? sewerageTreatmentPlantsCount == null
        //         ? "..."
        //         : `${numeral(sewerageTreatmentPlantsCount).format(format)}`
        //     : ``;

        return visible.current
            ? sewerageTreatmentPlantsCount == null
                ? { start: null, end: null, decimal: null }
                : {
                      start: getStart(sewerageTreatmentPlantsCount),
                      end: sewerageTreatmentPlantsCount,
                      decimal: getDecimalDigit(sewerageTreatmentPlantsCount)
                  }
            : { start: null, end: null, decimal: null };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [visible.current, sewerageTreatmentPlantsCount]);

    const waterTreatmentPlantsCountSetup = useMemo(() => {
        // return visible.current
        //     ? waterTreatmentPlantsCount == null
        //         ? "..."
        //         : `${numeral(waterTreatmentPlantsCount).format(format)}`
        //     : ``;

        return visible.current
            ? waterTreatmentPlantsCount == null
                ? { start: null, end: null, decimal: null }
                : {
                      start: getStart(waterTreatmentPlantsCount),
                      end: waterTreatmentPlantsCount,
                      decimal: getDecimalDigit(waterTreatmentPlantsCount)
                  }
            : { start: null, end: null, decimal: null };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [visible.current, waterTreatmentPlantsCount]);

    const sewerageMainsLengthSetup = useMemo(() => {
        // return visible.current
        //     ? sewerageMainsLength == null
        //         ? "..."
        //         : `${numeral(sewerageMainsLength).format(format)}`
        //     : ``;

        return visible.current
            ? sewerageMainsLength == null
                ? { start: null, end: null, decimal: null }
                : {
                      start: getStart(sewerageMainsLength),
                      end: sewerageMainsLength,
                      decimal: getDecimalDigit(sewerageMainsLength)
                  }
            : { start: null, end: null, decimal: null };

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [visible.current, sewerageMainsLength]);

    const potableWaterSuppliedCapacitySetup = useMemo(() => {
        // return visible.current
        //     ? potableWaterSuppliedCapacity == null
        //         ? "..."
        //         : `${numeral(potableWaterSuppliedCapacity).format(format)}`
        //     : ``;

        return visible.current
            ? potableWaterSuppliedCapacity == null
                ? { start: null, end: null, decimal: null }
                : {
                      start: getStart(potableWaterSuppliedCapacity),
                      end: potableWaterSuppliedCapacity,
                      decimal: getDecimalDigit(potableWaterSuppliedCapacity)
                  }
            : { start: null, end: null, decimal: null };

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [visible.current, potableWaterSuppliedCapacity]);

    const connectedPropertiesCountSetup = useMemo(() => {
        // return visible.current
        //     ? connectedPropertiesCount == null
        //         ? "..."
        //         : `${numeral(connectedPropertiesCount).format(format)}`
        //     : ``;

        return visible.current
            ? connectedPropertiesCount == null
                ? { start: null, end: null, decimal: null }
                : {
                      start: getStart(connectedPropertiesCount),
                      end: connectedPropertiesCount,
                      decimal: getDecimalDigit(connectedPropertiesCount)
                  }
            : { start: null, end: null, decimal: null };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [visible.current, connectedPropertiesCount]);

    const onScroll = useMemo(() => {
        // shouldRender.current = true;
        visible.current = false;

        // use this id to avoid race condition running onScroll
        // const uid = uuid();
        // scrollFunctionIdRef.current = uid;

        // console.log("numbers might be changed", numbers, id);

        return () => {
            const deltaTime = Date.now() - currentTime.current;

            if (ref.current && !visible.current && deltaTime > sleepingTime.current) {
                // const scrollY = window.scrollY ?? 0;
                // const panelY = (ref.current as Element)?.getBoundingClientRect()?.y ?? 0;
                // // const height = (ref.current as Element)?.getBoundingClientRect()?.height ?? 0;
                // // const scrollToY = Math.max(scrollY + panelY + height / 2, 0);
                // const scrollToY = Math.max(scrollY + panelY + 0, 0);
                // const scrollToScreen = scrollY + window.innerHeight ?? 0;

                // if (scrollToScreen <= scrollToY) {
                //     selfOnScroll.current && window.requestAnimationFrame(selfOnScroll.current);
                //     return;
                // }

                const scrollY = window.scrollY ?? 0;
                const panelY = (ref.current as Element)?.getBoundingClientRect()?.y ?? 0;
                const height =
                    (ref.current as Element)?.getBoundingClientRect()?.height ?? (ref.current as Element)?.clientHeight;

                const objectY0 = Math.max(scrollY + panelY, 0);
                const objectY1 = objectY0 + Math.max(window.innerHeight * 0.3, height);
                const screenY0 = scrollY;
                const screenY1 = scrollY + window.innerHeight ?? 0;

                if (
                    !((objectY0 <= screenY1 && screenY0 <= objectY0) || (objectY1 <= screenY1 && screenY0 <= objectY1))
                ) {
                    selfOnScroll.current && window.requestAnimationFrame(selfOnScroll.current);
                    return;
                }

                visible.current = true;
                setRefresh({ refresh: true });
            } else {
                selfOnScroll.current && window.requestAnimationFrame(selfOnScroll.current);
            }
        };
    }, []);

    useEffect(() => {
        // set start detect render
        // onScroll();
        const newOnScroll = _.debounce(onScroll, 50);
        // window.addEventListener("scroll", newOnScroll);

        // return () => {
        //     window.removeEventListener("scroll", newOnScroll);
        // };

        selfOnScroll.current = newOnScroll;
        window.requestAnimationFrame(selfOnScroll.current);
    }, [onScroll]);

    const adjustFontSize = useCallback(() => {
        const div = ref.current as HTMLDivElement;
        if (!div) return;

        const width = div.clientWidth;

        settings.forEach(({ className, widthRatio, lineHeightRatio }) => {
            const divs = div.querySelectorAll(`.${className}`);
            divs.forEach(d => {
                (d as HTMLElement).style.fontSize = `${width * widthRatio}px`;
                (d as HTMLElement).style.lineHeight = `${width * lineHeightRatio}px`;
            });
        });
    }, []);

    const formattingFn = useCallback((value: number) => {
        return `${numeral(value).format(format)}`;
    }, []);

    const formattingDollarFn = useCallback((value: number) => {
        return `$${numeral(value).format(format)}`;
    }, []);

    return (
        <div className={`${styles.info} ${className}`} ref={ref}>
            <div className={styles.pipe}>
                <PipeSystem />
            </div>
            <div className={styles.icon}>
                <PipeIconSystem />
            </div>
            <div className={styles.buttons}>
                <div className={styles.waterServiceProvider}>
                    <Link
                        to={buildUri(ROUTE.SEARCH_PAGE, {}, {})}
                        className={`${styles.linkButton}`}
                        onClick={() => {
                            infographicExploreProviderEvent();
                        }}
                    >
                        <div className={styles.waterServiceProviderButton}>
                            {/* <TextTransition text={strWaterServiceProviderCount} springConfig={presets.gentle} /> */}
                            <div className={settings[0].className}>
                                {waterServiceProviderCountSetup.start == null ? (
                                    "..."
                                ) : (
                                    <CountUp
                                        start={waterServiceProviderCountSetup.start}
                                        // style={style}
                                        end={waterServiceProviderCountSetup.end}
                                        duration={1}
                                        decimals={waterServiceProviderCountSetup.decimal}
                                        // className={`${styles?.[variant] ?? ""} ${className ?? ""}`}
                                        formattingFn={formattingFn}
                                    />
                                )}
                            </div>

                            <div className={settings[1].className}>water service providers</div>
                        </div>
                    </Link>
                </div>

                <div className={styles.capitalOperationSpending}>
                    {/* <TextTransition text={strCapitalOperationsSpentAmount} springConfig={presets.gentle} /> */}
                    <div className={settings[4].className}>
                        {capitalOperationsSpentAmountSetup.start == null ? (
                            "..."
                        ) : (
                            <CountUp
                                start={capitalOperationsSpentAmountSetup.start}
                                end={capitalOperationsSpentAmountSetup.end}
                                duration={1}
                                decimals={capitalOperationsSpentAmountSetup.decimal}
                                formattingFn={formattingDollarFn}
                            />
                        )}
                    </div>

                    <div className={settings[5].className}>billion spent</div>
                    <div className={settings[6].className}>on capital and operations</div>
                </div>

                <div className={styles.waterMainsLength}>
                    {/* <TextTransition text={strWaterMainsLength} springConfig={presets.gentle} /> */}
                    <div className={settings[2].className}>
                        {waterMainsLengthSetup.start == null ? (
                            "..."
                        ) : (
                            <CountUp
                                start={waterMainsLengthSetup.start}
                                end={waterMainsLengthSetup.end}
                                duration={1}
                                decimals={waterMainsLengthSetup.decimal}
                                // className={settings[2].className}
                                formattingFn={formattingFn}
                            />
                        )}
                    </div>
                    <div className={settings[3].className}>km of water mains</div>
                </div>

                <div className={styles.sewerageTreatmentPlants}>
                    {/* <TextTransition text={strSewerageTreatmentPlantsCount} springConfig={presets.gentle} /> */}
                    <div className={settings[7].className}>
                        {sewerageTreatmentPlantsCountSetup.start == null ? (
                            "..."
                        ) : (
                            <CountUp
                                start={sewerageTreatmentPlantsCountSetup.start}
                                end={sewerageTreatmentPlantsCountSetup.end}
                                duration={1}
                                decimals={sewerageTreatmentPlantsCountSetup.decimal}
                                formattingFn={formattingFn}
                            />
                        )}
                    </div>
                    <div className={settings[8].className}>sewage treatment plants</div>
                </div>

                <div className={styles.waterTreatmentPlants}>
                    {/* <TextTransition text={strWaterTreatmentPlantsCount} springConfig={presets.gentle} /> */}
                    <div className={settings[9].className}>
                        {waterTreatmentPlantsCountSetup.start == null ? (
                            "..."
                        ) : (
                            <CountUp
                                start={waterTreatmentPlantsCountSetup.start}
                                end={waterTreatmentPlantsCountSetup.end}
                                duration={1}
                                decimals={waterTreatmentPlantsCountSetup.decimal}
                                formattingFn={formattingFn}
                            />
                        )}
                    </div>
                    <div className={settings[10].className}>water treatment plants</div>
                </div>

                <div className={styles.sewerageMainsLength}>
                    {/* <TextTransition text={strSewerageMainsLength} springConfig={presets.gentle} /> */}
                    <div className={settings[11].className}>
                        {sewerageMainsLengthSetup.start == null ? (
                            "..."
                        ) : (
                            <CountUp
                                start={sewerageMainsLengthSetup.start}
                                end={sewerageMainsLengthSetup.end}
                                duration={1}
                                decimals={sewerageMainsLengthSetup.decimal}
                                formattingFn={formattingFn}
                            />
                        )}
                    </div>
                    <div className={settings[12].className}>km of sewerage mains</div>
                </div>

                <div className={styles.potableWaterSupplied}>
                    <div className={settings[13].className}>
                        {/* <TextTransition
                            text={strPotableWaterSuppliedCapacity}
                            springConfig={presets.gentle}
                            style={{
                                display: "inline-block"
                            }}
                        />{" "} */}

                        {potableWaterSuppliedCapacitySetup.start == null ? (
                            "..."
                        ) : (
                            <CountUp
                                start={potableWaterSuppliedCapacitySetup.start}
                                end={potableWaterSuppliedCapacitySetup.end}
                                duration={1}
                                decimals={potableWaterSuppliedCapacitySetup.decimal}
                                formattingFn={formattingFn}
                            />
                        )}

                        <div className={`${styles.valueSuffix} ${settings[14].className}`}>ML</div>
                    </div>
                    <div className={settings[15].className}>of drinking water supplied</div>
                </div>

                <div className={styles.connectedProperties}>
                    {/* <TextTransition
                        text={strConnectedPropertiesCount}
                        springConfig={presets.gentle}
                        style={{
                            display: "inline-block"
                        }}
                    /> */}
                    <div className={settings[16].className}>
                        {connectedPropertiesCountSetup.start == null ? (
                            "..."
                        ) : (
                            <CountUp
                                start={connectedPropertiesCountSetup.start}
                                end={connectedPropertiesCountSetup.end}
                                duration={1}
                                decimals={connectedPropertiesCountSetup.decimal}
                                formattingFn={formattingFn}
                            />
                        )}
                    </div>
                    <div className={settings[17].className}>connected properties</div>
                </div>
            </div>

            <ReactResizeDetector handleWidth={true} handleHeight={true} onResize={adjustFontSize} />
        </div>
    );
};
